import React, { memo, useContext } from 'react';

import { ZebraPrinterProvider } from '../../Context/ZebraPrinterContext';
import { AccessProvider } from '../../Context/AccessContext';
import { WebSocketProvider } from '../../Context/WsContext';
import { MainContext } from '../../Context/MainContext';
import './Main.css';

import Header from './Header';
import PopupStatus from '../Templates/PopupStatus';

const AllContexts = ({ children }) => (
    <AccessProvider>
        <WebSocketProvider>
            <ZebraPrinterProvider>
                {children}
            </ZebraPrinterProvider>
        </WebSocketProvider>
    </AccessProvider>
);

const PopupStatusWrapper = memo(() => {

    const { status, setStatus } = useContext(MainContext);

    return <PopupStatus status={status} statusToggle={() => setStatus({})} />;
});

const Main = ({ children }) => {
    return(
        <AllContexts>
            <div className="main">
                <Header />
                {children}
                <PopupStatusWrapper />
            </div>
        </AllContexts>
    );
};

export default Main;